import React, { useState, useEffect } from 'react';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BackButton } from '../../../../components';
import { Block, Icon, Text } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import CardPayment from '../../Reincorporation/progress/components/CardPayment';
import constants from '../../../../constants';
import CardProgress from '@/presentation/reusables/CardProgress';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import ButtonCancelRequest from '@/presentation/components/ButtonCancelRequest';
import CancelProcedure from '../../CertificateOfStudies/dialogs/CancelProcedure';
import Spinner from '@/presentation/components/Spinner';
import Processing from '@/presentation/components/Processing';
import AnulledFinalState from '../../RetreatCourse/progress/components/AnulledFinalState';

const LateExamenProgressView = ({
  handlerBackButton,
  procedure,
  request,
  handlerActivatePayment,
  isLoadingActivatePayment,
  isSuccessActivatePayment,
  handlerShowAnulate,
  handlerCancelProcedure,
  handlerClose,
  showModalAnulate,
  isLoadingDetail
}: any) => {
  const evalStatus = () =>
    constants.procedureStatus.examStragglers.find(
      (s: any) => s.name === request?.status.status
    );
  const [isPaymentActive, setIsPaymentActive] = useState(false);
  const [isPaymentDone, setIsPaymentDone] = useState(false);

  const formatResumeFailed = () => {
    const html = `
    <div class="resumeReincorporation">
    <br/>
    Tu solicitud no procedió debido a que no realizaste el pago a tiempo.
    <div>`;
    return html;
  };

  const formatResumeSuccess = () => {
    const html = `<div class="resumeExamStraggles">
    <p style="text-align: justify">
    Recibirás un mensaje cuando tengas la hora, lugar o link de acceso y docente asignado.
    <p>
    `;
    return html;
  };
  useEffect(() => {
    if (request) {
      const { requiresPayment, payed } = request;
      setIsPaymentActive(
        requiresPayment && evalStatus()?.name === 'PAGO_ACTIVADO' && !payed
      );
      setIsPaymentDone(requiresPayment && payed);
    }
  }, [request]);

  return (
    <ContainerProcedure>
      {isLoadingDetail && <Spinner />}
      {!isLoadingDetail && procedure && (
        <SubContainer>
          <BackButton onClick={handlerBackButton} />
          <Processing isOpen={isLoadingDetail} />
          <ToggleHeader
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            date={procedure?.endDate}
            status={request?.status}
            star="*"
            childContent={<ProcedureInfoComponent inRegister />}
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              isFirst
              name={procedure.steps[0].name}
              order={procedure.steps[0].order}
              date={procedure.steps[0].date?.toLowerCase()}
              isComplete
              isCurrent={procedure.steps[0].isCurrent}
            >
              <>
                <p>Resumen:</p>
                <li>{procedure?.detail?.course}.</li>
                <li>{procedure?.detail?.test}.</li>
              </>
            </Step>
            <Step
              name={procedure?.steps[1]?.name}
              order={procedure?.steps[1]?.order}
              isComplete={request?.status.status === 'FINALIZADO' && true}
              disabled={
                evalStatus()?.name === 'ANULADO' ||
                request.status.status === 'NO_PROCEDE'
              }
            >
              {request?.requiresPayment ? (
                <>
                  {evalStatus()?.name === 'CREADO' && (
                    <CardPayment
                      title="Genera el cargo de tu trámite activando tu pago"
                      infoText="Recuerda que una vez realizado el pago, se procederá con los demás pasos."
                      buttonText="Activar"
                      isPaymentActive={isPaymentActive}
                      isPaymentDone={isPaymentDone}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={isLoadingActivatePayment}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                      firstDialogSubtitle={`Al aceptar, se cargará el monto de S/${procedure?.amount}.00 a tus pagos pendientes.`}
                    />
                  )}
                  {evalStatus()?.name === 'PAGO_ACTIVADO' && !isPaymentDone && (
                    <CardPayment
                      title="El pago ha sido activado"
                      infoText="Recuerda que una vez realizado el pago, se procederá con los demás pasos."
                      buttonText="Ir a pagos"
                      isPaymentActive
                      isPaymentDone={false}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={isLoadingActivatePayment}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                      secondDialogSubtitle={
                        'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago procederá tu solicitud.'
                      }
                    />
                  )}
                  {evalStatus()?.name === 'PAGO_ACTIVADO' && isPaymentDone && (
                    <>Pago en proceso</>
                  )}
                  {/* {['FINALIZADO', 'PENDIENTE'].includes(
                    evalStatus()?.name || ''
                  ) && <>{procedure?.steps[1]?.date?.toLowerCase()}</>} */}
                </>
              ) : (
                <>Este trámite no tiene costo</>
              )}
            </Step>
            <Step
              name={procedure?.steps[2]?.name}
              order={procedure?.steps[2]?.order}
              isComplete={
                evalStatus()?.name === 'ANULADO'
                  ? true
                  : evalStatus()?.isComplete
              }
              disabled={
                evalStatus()?.name === 'ANULADO'
                  ? false
                  : !evalStatus()?.isComplete
              }
              isLast
            >
              {/* {evalStatus()?.isComplete &&
              !(request?.requiresPayment && !isPaymentDone) ? (
                <CardProgress
                  image={[requestInProgressImage, requestInProgressDskImage]}
                  title={`Tu reincorporación para el ciclo ${procedure?.detail?.applySince} está pendiente`}
                  subtitle={formatResumePending()}
                />
              ) : (
                <></>
              )} */}
              {evalStatus()?.isComplete && evalStatus()?.isApproved && (
                <CardProgress
                  image={[documentSuccessImage, documentSuccessDskImage]}
                  title={`Tu solicitud ${procedure?.detail?.applySince} ha sido aprobada`}
                  subtitle={formatResumeSuccess()}
                >
                  <Block
                    customized
                    backgroundColor="#ECF4F9"
                    minHeight="32px"
                    padding="8px 16px"
                    borderRadius="8px"
                    margin="12px 0px 0px"
                    flexDirection="row"
                  >
                    <Icon name="alert-circle" size="16" />
                    <Block customized margin="0px 0px 0px 8px">
                      <Text
                        color="#161D1F"
                        fontSize="12px"
                        lineHeight="16px"
                        fontWeight="400"
                        textAlign="left"
                      >
                        Recibirás un mensaje a tu correo institucional cuando
                        esté programado tu examen y lo podrás ver en tu rol de
                        exámenes.
                      </Text>
                    </Block>
                  </Block>
                </CardProgress>
              )}
              {evalStatus()?.isComplete && !evalStatus()?.isApproved && (
                <CardProgress
                  image={[documentFailedImage, documentFailedDskImage]}
                  title={`Tu solicitud no procede`}
                  subtitle={formatResumeFailed()}
                />
              )}
              {evalStatus()?.name === 'ANULADO' && (
                <AnulledFinalState procedure={procedure} />
              )}
            </Step>
          </Block>
          {(evalStatus()?.name === 'CREADO' ||
            (evalStatus()?.name === 'PAGO_ACTIVADO' && !isPaymentDone)) && (
            <ButtonCancelRequest handlerShowAnulate={handlerShowAnulate} />
          )}
          <CancelProcedure
            handlerCancelProcedure={handlerCancelProcedure}
            handlerClose={handlerClose}
            show={showModalAnulate}
          />
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default LateExamenProgressView;
